import { useCallback, useContext } from 'react';

import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { sendAnalyticsInfo } from 'features/analytics/helpers';
import { LogLevel } from 'features/analytics/enums';
import { SipSessionEventBus } from 'features/sip/services/';
import { SipSessionContext } from 'features/sip/contexts';
import {
  isDeafConnectedSelector,
  selectIsDeafUserFromSorenson,
} from 'features/call/call-deaf/store';
import { isTeamingInProgressSelector } from 'features/teaming/teaming-base/store';
import { selectIsViConnectedToFreeSwitchConference } from 'features/caller-session/store';

export const useEnableFlasher = () => {
  const session = useContext(SipSessionContext);
  const dispatch = useAppDispatch();
  const isDeafConnected = useAppSelector(isDeafConnectedSelector);
  const isSorenson = useAppSelector(selectIsDeafUserFromSorenson);
  const isTeamingInProgress = useAppSelector((state) =>
    isTeamingInProgressSelector(state)
  );
  const isViInFreeSwitchRoom = useAppSelector(
    selectIsViConnectedToFreeSwitchConference
  );
  const showEnableFlasher =
    isDeafConnected &&
    isSorenson &&
    !isTeamingInProgress &&
    !isViInFreeSwitchRoom;

  const handleEnableFlasher = useCallback(() => {
    const contentType = 'application/im-poke+xml';
    const body =
      '<?xml version="1.0" encoding="UTF-8"?>\n<poke xmlns="urn:ietf:params:xml:ns:im-poke" />';
    const target = session?.remote_identity?.uri?.toString() || '';
    if (target) {
      SipSessionEventBus.outgoingMessage$.next({ target, body, contentType });
      // Log success via analytics and dispatch
      sendAnalyticsInfo({
        Method: 'EnableFlasher',
        Message: 'Sent SIP poke message',
        Target: target,
        Level: LogLevel.INFO,
      });
    } else {
      // Log error via analytics and dispatch
      dispatch(
        sendAnalyticsInfo({
          Method: 'EnableFlasher',
          Message: 'No valid SIP target found',
          Level: LogLevel.ERROR,
        })
      );
    }
  }, [session, dispatch]);
  return [showEnableFlasher, handleEnableFlasher] as const;
};
